import { Component, Input } from '@angular/core';

@Component({
	selector: 'print-btn',
	template: require('./print-btn.html')
})
export class PrintBtnComponent {
	@Input('isDisabled') isDisabled = false;
	constructor() {}
	print() {
		window.print();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/buttons/print-btn/print-btn.ts